import React from 'react'

function Sport() {
  return (
    <div>
      <button className='peer text-white lg:text-gray-700 font-semibold lg:font-normal text-center text-md  lg:text-sm'  >Spor & Outdoor</button>
      <div className='hidden peer-hover:flex hover:flex absolute'>
        <div className='p-2 md:p-3 lg:p-4 z-20 rounded-xl bg-gradient-to-r from-purple-500 to-pink-500 border border-gray-400 lg:border-none mt-2 lg:mt-6 cursor-pointer w-80 md:w-97 lg:w-90 text-center mr-5'>
            <div className='p-1 lg:p-2 space-x-2 grid grid-cols-2 md:grid-cols-5 '>
                <ul className='space-y-1 text-gray-700 text-xs md:text-sm font-[500] mt-2' >
                    <h6 className='text-xs md:text-sm font-500 text-gray-300 underline'>Spor Giyim</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Tişört</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Tayt</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Şort</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Eşofman</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Sporcu Sütyeni</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Yelek</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Atlet</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Forma</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Mont</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Spor Çorap</li>
                </ul>

                <ul className='space-y-1 text-gray-700 text-xs md:text-sm font-[500] mt-2' >
                    <h6 className='text-xs md:text-sm font-500 text-gray-300 underline'>Spor Ayakkabı</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Koşu Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Futbol Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Basketbol Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Deniz Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Fitness Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Kaykay Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Yürüyüş Ayakkabısı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Outdorr Ayakkabı</li>
            
                </ul>
                
                <ul className='space-y-1 text-gray-700 text-xs md:text-sm font-[500] mt-2' >
                    <h6 className='text-xs md:text-sm font-500 text-gray-300 underline'>Spor Malzemeleri</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Dağcılık</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Deniz & Plaj</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Paten</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Kaykay</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'> Kamp Malzemeleri</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Tenis Malzemeleri</li>
            
                </ul>
                <ul className='space-y-1 text-gray-700 text-xs md:text-sm font-[500] mt-2' >
                    <h6 className='text-xs md:text-sm font-500 text-gray-300 underline'>Fitness</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Dambıl Seit</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Sporcu Eldiveni</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Fıtness Aletleri</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Kondisyon Bisikleti</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Koşu Bandı</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Pilates Malzemeleri</li>
               
            
                </ul>
                <ul className='space-y-1 text-gray-700 text-xs md:text-sm font-[500] mt-2' >
                    <h6 className='text-xs md:text-sm font-500 text-gray-300 underline'>Sporcu Besinleri</h6>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Protein Tozu</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Amino Asit</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Kreatin</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Bcaa</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>L-Karnitin</li>
                    <li className='hover:text-violet-700 duration-500 hover:underline'>Gıda Takviyesi</li>
                    
            
                </ul>
            </div>
        </div>
      </div>

    </div>
  )
}

export default Sport
